exports.default = "WebpackMultiOutput-/home/runner/work/web/web/static/nls/labs-common.js-WebpackMultiOutput";